import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import NewHome from './Components/NewHome';
import Footer from './Components/Footer';
import Home from './Components/Home';
import CreateModel from './Components/CreateModel';
import Configure from './Components/Configure';
import Login from './Components/Login';
import MyAgents from './Components/MyAgents';
import AboutUs from './Components/AboutUs';
import ModularB2B from './Components/ModularB2B';
import TailoredB2B from './Components/TailoredB2B';
import B2B_Blog_Lists from './Components/B2B_Blog_Lists';
import EnglishAI_Posting from './Components/usecases/englishAI_posting';
import DeFi_Posting from './Components/usecases/defi_posting';
import RealEstateAI_Posting from './Components/usecases/realestateAI_posting';

import AccessQuote from './Components/AccessQuote';
import QuoteDisplay from './Components/QuoteDisplay';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        {/* New home as root */}
        <Route path="/" element={<NewHome />} />
        {/* Old Home accessible via Agents Hub */}
        <Route path="/agents-hub" element={<Home />} />

        <Route path="/create" element={<CreateModel />} />
        <Route path="/configure" element={<Configure />} />
        <Route path="/login" element={<Login />} />
        <Route path="/myagents" element={<MyAgents />} />
        <Route path="/about" element={<AboutUs />} />

        <Route path="/b2b/modular" element={<ModularB2B />} />
        <Route path="/b2b/tailored" element={<TailoredB2B />} />
        <Route path="/b2b/use-cases" element={<B2B_Blog_Lists />} />
        <Route path="/b2b/use-cases/english-ai" element={<EnglishAI_Posting />} />
        <Route path="/b2b/use-cases/defi" element={<DeFi_Posting />} />
        <Route path="/b2b/use-cases/realestate" element={<RealEstateAI_Posting />} />

        <Route path="/b2b/quote" element={<AccessQuote />} />
        <Route path="/b2b/quote/:code" element={<QuoteDisplay />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;




// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }